import {getLineNumberWidth} from '@github-ui/diffs/diff-line-helpers'
import {UnifiedDiffLines} from '@github-ui/diffs/DiffParts'
import {clsx} from 'clsx'

import type {StaticDiffLine} from '../../conversation-types'
import styles from './StaticUnifiedDiffPreview.module.css'

type StaticUnifiedDiffPreviewProps = {
  diffLines?: StaticDiffLine[]
  tabSize: number
  className?: string
  diffTableClassName?: string
}

/**
 * Renders a static representation of a unified diff
 * Specifically for use in outdated threads, which return a slightly different set of difflines
 */
export function StaticUnifiedDiffPreview({
  diffLines,
  tabSize,
  className,
  diffTableClassName,
}: StaticUnifiedDiffPreviewProps) {
  if (!diffLines || diffLines.length < 1) {
    return null
  }

  const lineWidth = getLineNumberWidth(diffLines)

  return (
    <div className={clsx(styles.StaticDiffPreview, className)}>
      <UnifiedDiffLines lineWidth={lineWidth} lines={diffLines} tabSize={tabSize} className={diffTableClassName} />
    </div>
  )
}

try{ StaticUnifiedDiffPreview.displayName ||= 'StaticUnifiedDiffPreview' } catch {}